// extracted by mini-css-extract-plugin
export default {"main":"Player_main__l4Bj-","face":"Player_face__1K1g5","info":"Player_info__J5+gN","hand":"Player_hand__jVAEC","active":"Player_active__Lkswb","pulse":"Player_pulse__rps6l"};